// @ts-nocheck

export const normalizeTaggedUsers = (users = []) => {
    if (!Array.isArray(users)) return [];

    return users
        .map((u) => {
            if (!u) return undefined;
            if (typeof u === 'string') return { userId: u, name: u };
            return {
                userId: u.userId || u.id || u.value,
                name: u.name || [u.firstName, u.lastName].filter(Boolean).join(' ').trim() || u.email || u.userId || u.id,
                email: u.email,
            };
        })
        .filter(Boolean)
        .filter((u, i, arr) => u.userId && arr.findIndex((x) => x.userId === u.userId) === i);
};

export const resolveNoteAuthorName = (note, usersById = {}, fallbackName = '-') => {
    const authorId = note?.createdBy?.userId || note?.updatedBy?.userId;
    if (!authorId && note?.sender?.name) return note.sender.name;
    if (!authorId) return fallbackName;

    const mapped = usersById[authorId];
    if (mapped?.name) return mapped.name;

    return authorId;
};

export const getNoteDate = (note) => note?.updatedAt || note?.createdAt || note?.date;

export const getNoteId = (note) => note?.noteId || note?._id || note?.legacyId;

export const collectAllTaggedUsers = (notes = []) => {
    if (!Array.isArray(notes)) return [];
    return notes
        .flatMap(n => normalizeTaggedUsers(n.mentionTags))
        .filter((u, i, arr) => u.userId && arr.findIndex(x => x.userId === u.userId) === i);
};
